import { render, staticRenderFns } from "./ExpedienteDetailCard.vue?vue&type=template&id=639fdd16&scoped=true&"
import script from "./ExpedienteDetailCard.vue?vue&type=script&lang=js&"
export * from "./ExpedienteDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteDetailCard.vue?vue&type=style&index=0&id=639fdd16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fdd16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardTitle,
  VContainer,
  VDivider,
  VFlex,
  VIcon,
  VLayout,
  VProgressCircular,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
